// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".logic-view{height:auto;min-height:100vh;max-height:100vh;overflow-y:auto}", ""]);
// Exports
module.exports = exports;
